import styled, { css } from 'styled-components';
import { em, rem } from 'styles';
import { PALETTE } from 'pages/Fields/fields.constants';

export const Card = styled.section`
  ${({ theme }) => css`
    display: flex;
    flex-direction: column;
    gap: ${em(12)};
    padding: ${em(16)};
    background: ${theme.colors.nature.n0};
    border-radius: ${em(theme.radius[0])};
    box-shadow: ${theme.shadows()[0]};
  `}
`;

export const Stats = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: ${em(32)};
`;

export const Stat = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${em(2)};
`;

export const Value = styled.span`
  ${({ theme }) => css`
    font-family: ${theme.fonts.mono};
    font-size: ${rem(22)};
    font-weight: ${theme.fontWeights[1]};
    color: ${theme.colors.nature.n5};
  `}
`;

export const Label = styled.span`
  ${({ theme }) => css`
    font-size: ${rem(14)};
    color: ${theme.colors.nature.n3};
  `}
`;

export const FieldButton = styled.button`
  padding: 0;
  font-size: inherit;
  color: ${PALETTE.brandDark};
  text-decoration: underline;
  background: none;
  border: 0;
  cursor: pointer;
`;

export const ImgWrap = styled.div`
  position: relative;
  overflow: auto;
  max-height: ${em(520)};
  background: ${PALETTE.panel};
  border: ${em(1)} solid ${PALETTE.line};
  border-radius: ${em(6)};

  img {
    display: block;
    width: ${({ $full }) => ($full ? 'auto' : '100%')};
  }
`;

export const NoImage = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: ${em(220)};
  font-size: ${rem(15)};
  color: ${PALETTE.faint};
  background: ${PALETTE.panel};
  border: ${em(1)} dashed ${PALETTE.line};
  border-radius: ${em(6)};
`;

export const ImageLoader = styled.div`
  position: absolute;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: ${rem(15)};
  color: ${PALETTE.muted};
  background: ${PALETTE.panel};
`;

export const Actions = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: ${em(8)};
`;

const pill = css`
  padding: ${em(7)} ${em(16)};
  font-size: ${rem(15)};
  border-radius: ${em(18)};
  cursor: pointer;

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
`;

export const ConfirmButton = styled.button`
  ${pill}
  color: #fff;
  background: ${PALETTE.brand};
  border: ${em(1)} solid ${PALETTE.brand};

  &:hover:not(:disabled) {
    background: ${PALETTE.brandDark};
  }
`;

export const RejectButton = styled.button`
  ${pill}
  color: #b3261e;
  background: transparent;
  border: ${em(1)} solid #e6b8b4;

  &:hover:not(:disabled) {
    background: #fcefee;
  }
`;

export const GhostButton = styled.button`
  ${pill}
  color: ${PALETTE.ink};
  background: transparent;
  border: ${em(1)} solid ${PALETTE.line};

  &:hover:not(:disabled) {
    background: ${PALETTE.panel};
  }
`;

export const ErrorText = styled.div`
  font-size: ${rem(14)};
  color: #b3261e;
`;
